operationDefinition